import PaginationRequest from '@/common/pagination/entities/pagination-request'

export default class LogwoodShiftPackageFilter {
  public paging: PaginationRequest = new PaginationRequest()
}